const globalErrorMessages = {
  wrongProjectId: 'Wrong project ID',
  wrongCredentials: 'Email address or password incorrect. Try again or reset your password.',
  projectNotFound: 'Project not found.',
  userNotFound: 'User not found.',
  emptyEmail: 'Enter your email address.',
  invalidEmail: 'Enter a valid email address.',
  emptyPassword: 'Enter your password.',
  emptyConfirmPassword: 'Enter your confirm password.',
  invalidPassword: 'Enter a valid password.',
  confirmPasswordMatch: 'Your passwords do not match. Try again.',
  invalidPasswordCriteria: 'Password does not meet criteria. Try again.',
  remainingLoginAttempt: 'You have remainingLoginAttempt more attempts before your account is temporarily locked for 24 hours. Try again or reset your password',
  networkError: 'Server handshake is failed.',
  somethingWentWrong: 'Something went wrong',
  unknownError: 'An unknown error occurred.',
  apiNoteFound: 'Request Failed',
  emptyTranslation: 'Enter your translation.',
  emptyReviewerTranslation: 'Enter your edits.',
  emailAlreadyExist: 'Email address taken.',
  notAuthenticated: 'Not authenticated',
  unauthorized: 'You don\'t have permission to perform this action',
  invalidCredentials: 'Invalid Credentials',
  fetchingProjectUsers: 'Error fetching project users',
  savingProjectChanges: 'Error saving project changes',
  creatingProject: 'Error creating project',
  duplicateProjectName: 'Duplicate project name',
  creatingProjectMissingId: 'Error creating project: Missing project ID',
  addingUser: 'Error adding user',
  editingUser: 'Error editing user',
  editingUserMissingProjectId: 'Error editing user: Missing project ID',
  deletingUser: 'Error deleting user',
  addingAssignmentTime: 'Error adding assignment time',
  addingAssignmentTargetDate: 'Error adding assignment target date',
  fetchingUserData: 'Error fetching user data',
  fetchingLanguages: 'Error fetching languages',
  savingProfileChanges: 'Error saving profile changes',
  fetchingProjectDetails: 'Error fetching project details',
  fetchingProjects: 'Error fetching projects',
  fetchingAssignments: 'Error fetching assignments',
  resettingPassword: 'Error resetting password',
  sendingEmail: 'Error sending email',
  documentSourceIdNotFound: 'Document source ID not found',
  taskNotFound: 'Task not found',
  bookmarkingTask: 'Error bookmarking task',
  completingTask: 'Error completing task',
  submittingAssignment: 'Error submitting assignment',
  fetchingAssignment: 'Error fetching assignment',
  fetchingOrgUser: 'Error fetching organization user',
  fetchingCalculatedModel: 'Error fetching calculated model',
  fetchingTasks: 'Error fetching tasks',
  updatingTask: 'Error updating task',
  savingNote: 'Error saving note',
  fetchingChapters: 'Error fetching chapters',
  fetchingTargetLanguages: 'Error fetching target languages',
  fetchingSourceLanguages: 'Error fetching source languages',
  fetchingProfile: 'Error fetching profile',
  updatingProfile: 'Error updating profile',
  unknownErrorOccurred: 'Unknown error occurred',
  updatingSelectedModel: 'Error updating selected model',
  aiAutoInProgress: 'Training already in progress',
  aiAutoFrequencyExceeded: 'Max training frequency exceeded',
  aiAutoTriggerFailed: 'Error triggering machine translation',
  versionSkewReload: 'A new version is available. Reload the page to update.',
  noBookFound: 'No book found for the given module',
};

const usfmErrorMessages = {
  usfmURLVariableMissing: 'Error exporting to USFM: service URL not configured',
  usfmExportResponseFailed: 'Error exporting to USFM: Export request failed',
  usfmExportFetchFailed: 'Error exporting to USFM: Fetch request failed',
  usfmExportMissingUrl: 'Error exporting to USFM: Missing URL in response',
};

export const errorMessages = {
  ...globalErrorMessages,
  ...usfmErrorMessages,
};
